/* global axios */

import ApiClient from './ApiClient';

class TaccRemindersAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  remindersUrl(conversationId) {
    return `${this.url}/${conversationId}/tacc_reminders`;
  }

  getReminders(conversationId) {
    return axios.get(this.remindersUrl(conversationId), {
      headers: { 'Cache-Control': 'no-cache' },
    });
  }

  createReminder(conversationId, reminder) {
    return axios.post(this.remindersUrl(conversationId), { reminder });
  }

  updateReminder(conversationId, reminderId, reminder) {
    return axios.patch(`${this.remindersUrl(conversationId)}/${reminderId}`, {
      reminder,
    });
  }

  deleteReminder(conversationId, reminderId) {
    return axios.delete(`${this.remindersUrl(conversationId)}/${reminderId}`);
  }
}

export default new TaccRemindersAPI();
